/**
 * i18n-helper.ts - Centralized internationalization helper
 *
 * Provides a simple translation function that works with the global i18n instance.
 * Falls back to the provided default text if i18n is not available.
 */

interface I18nInstance {
  t(key: string): string;
  language: string;
  translations?: Record<string, any>;
}

declare global {
  interface Window {
    i18n?: I18nInstance;
  }
}

/**
 * Get translated text for a key, with fallback
 * @param key - Translation key (e.g., 'tournament.name')
 * @param fallback - Fallback text if translation not found
 * @returns Translated text or fallback
 */
export function t(key: string, fallback: string): string {
  return window.i18n ? window.i18n.t(key) : fallback;
}

/**
 * Check if i18n is initialized
 * @returns True if i18n is available
 */
export function hasI18n(): boolean {
  return !!window.i18n;
}

/**
 * Get current language code
 * @returns Current language code or 'en' as default
 */
export function getCurrentLanguage(): string {
  return window.i18n ? window.i18n.language : 'en';
}
